<template>
  <div class="leave-dialog">
    <div class="box">
      <div class="title">你確定提交嗎？</div>
      <div class="content"></div>
      <div class="content">仍有題目未作答完畢。</div>
      <div class="btn">
        <img src="@/assets/images/return-dialog.png" alt="" @click="returnTo">
        <img src="@/assets/images/submit.png" alt="" @click="leave">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  methods: {
    returnTo() {
      this.$emit('closeDialog')
    },
    leave() {
      this.$emit('confirm')
    }
  }
}
</script>

<style scoped lang="scss">
.leave-dialog {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9;

  .box {
    width: 400px;
    height: 230px;
    background-color: #fff;
    border-radius: 20px;
    display: flex;
    flex-wrap: wrap;
    align-content: space-around;
    padding: 20px 0;
    box-sizing: border-box;
    .title {
      width: 100%;
      font-size: 30px;
      text-align: center;
      color: #B62D2E;
      font-weight: 700;
    }

    .content {
      font-size: 20px;
      width: 100%;
      text-align: center;
      padding-bottom: 30px;
    }

    .btn {
      width: 100%;
      display: flex;
      justify-content: center;

      img {
        height: 50px;
        width: auto;
        margin: 0 10px;
        cursor: pointer;

        &:hover {
          opacity: .7;
        }
      }
    }
  }
}
</style>